<script setup>
import { inject, onMounted, onUpdated } from 'vue';
import { useProductsStore } from '@/app/stores/productsStore.js';
import ProductCard from '@/app/components/product-card/product-card.vue';
import ProductListingFilter from '@/app/components/product-listing/product-listing-filter.vue';

const config = inject('config');
const gaPush = inject('gaPush');
const productsStore = useProductsStore();

// to send data to GA after the first render
let updatedCount = 0;

onMounted(() => {
  productsStore.setLocales();
  productsStore.system = config.defaultSystem;
  productsStore.sortProducts(config.products);
  productsStore.filters = config.filters;
  productsStore.createFiltersLabels();
  productsStore.resetDynamicFiltersArr();
  productsStore.manageSystemToggleDisplay();
});

onUpdated(() => {
  updatedCount && handleProductsUpdate();
  updatedCount++;
});

function handleProductsUpdate() {
  const gaPayload = {
    event: 'prod_spec_load_product_list',
    selected_filters: productsStore.selectedFiltersListString,
    product_category: config.category,
    measurement_system: productsStore.system || null,
    number_returned_products: productsStore.productsFiltered.length,
  };
  gaPush(gaPayload);
}
</script>

<template>
  <div class="c-product-listing__background-wrapper">
    <ProductListingFilter />
    <div class="c-product-listing">
      <ul
        class="c-product-listing__card-list"
        itemscope
        itemtype="https://schema.org/ItemList"
        role="list"
      >
        <ProductCard
          v-for="(product, i) in productsStore.productsFiltered"
          :key="product.id"
          :product="product"
          :position="i + 1"
        />
      </ul>
    </div>
  </div>
</template>